@if (showClear) {
  <button type="button" class="btn btn-sm text-center btn-secondary w-100 clear-btn" translate (click)="clickClearFilter()">
    <span translate>CLEAR</span> ({{activeValues}})
  </button>
}
